import { useMutation, useQueryClient } from '@tanstack/react-query'

import { RequestsService } from '@/api/models/requests'
import { REQUEST_COMMENTS_QUERY_KEY } from '@/api/models/requests/hooks/useGetRequestCommentsList'
import { REQUEST_BY_ID_RQ_KEY } from '@/api/models/requests/hooks/useRequestById'

export const useReopenRequest = (requestId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => RequestsService.reopenRequest(requestId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [REQUEST_BY_ID_RQ_KEY, requestId]
      })
      queryClient.invalidateQueries({
        queryKey: [REQUEST_COMMENTS_QUERY_KEY, requestId]
      })
    }
  })
}
